import { clamp } from "lodash-es";
import type { PanBounds, Transform } from "web_myplann/Chat/Types/pinchZoom";

export const clampOffset = (
	transform: Transform,
	bounds: PanBounds,
): Transform => ({
	...transform,
	x: clamp(transform.x, -bounds.maxX, bounds.maxX),
	y: clamp(transform.y, -bounds.maxY, bounds.maxY),
});
